import * as IoC from 'inversify';
import { BookmarkDataStoreSymbol, BookmarkDataStore } from '../common/bookmark-data-store';
import { bookmarkCommonTrackingModule } from '../common/di'
import { XApiBookmarkStore } from './xapi-bookmark-store'

const bookmarkTinCanTrackingModule = new IoC.ContainerModule((bind) => {
  bind<BookmarkDataStore>(BookmarkDataStoreSymbol).to(XApiBookmarkStore)
})

export const bookmarkTinCanTrackingModules = [
  bookmarkCommonTrackingModule,
  bookmarkTinCanTrackingModule,
]
